export default __webpack_public_path__ + "static/media/โปรที่1BT86.26b764da.png";